export default __webpack_public_path__ + "static/media/ProductDefaultImage_transparent.c5d0e184.png";